// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_Slq","buttons":"Footer_buttons__2s8cs"};